import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { getNodeLabel } from '../../utils';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UiNode, UiNodeInputAttributes } from '../../../../sdk/kratos';

@Component({
    selector: 'app-form-input',
    imports: [ReactiveFormsModule, NgClass],
    templateUrl: './form-input.component.html',
    styleUrl: './form-input.component.less'
})
export class FormInputComponent {

  @Input()
  form!: FormGroup;

  @Input()
  node!: UiNode;

  @Input({required: true})
  nodeId!: string;

  @Input()
  isFormSubmitting: boolean = false;

  get disabled(): boolean {
    return this.attributes.disabled;
  }

  get attributes(): UiNodeInputAttributes {
    return this.node.attributes as UiNodeInputAttributes;
  }

  get hasError(): boolean {
    return this.node.messages.some(({type}) => type === 'error');
  }

  get messageIds(): string | null {
    if (!this.node.messages.length) {
      return null;
    }

    return this.node.messages
      .map((_, index) => `${this.nodeId}-message-${index}`)
      .join(' ');
  }

  get inputCtrlType(): string
  {
    switch(this.attributes.type) {
      case "hidden":
      case "checkbox":
      case "button":
      case "submit":
        return this.attributes.type;
      default:
        return 'default'
    }
  }

  protected readonly getNodeLabel = getNodeLabel;
}
